module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "header-view"
  }, [_c('div', {
    staticClass: "header-view-wrapper"
  }, [_c('VwHeader', {
    attrs: {
      "title": "Title-1"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-h",
    slot: "right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-view-wrapper"
  }, [_c('VwHeader', {
    attrs: {
      "title": "Title-2"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    slot: "left"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "header-view-wrapper"
  }, [_c('VwHeader', {
    attrs: {
      "title": "Title-3"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h",
    slot: "right"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-d07236a4!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/headerView.vue
// module id = 287
// module chunks = 0